import { combineReducers } from 'redux';

import { appReducer } from './appSlice';
import { brandReducer } from './brandSlice';
import { chatbotReducer } from './chatbotSlice';
import { contractsReducer } from './contractsSlice';
import { impersonationReducer } from './impersonationSlice';
import { networkReducer } from './networkSlice';
import { toastReducer } from './toastSlice';
import { userReducer } from './userSlice';

export const rootReducer = combineReducers({
    app: appReducer,
    toast: toastReducer,
    user: userReducer,
    contracts: contractsReducer,
    brand: brandReducer,
    network: networkReducer,
    impersonation: impersonationReducer,
    chatbot: chatbotReducer,
});
